import { UserResource } from '@/api/resources/UserResource.js'

export class LoginResultResource
{
	data = new LoginResultResourceData()
}

export class LoginResultResourceData
{
	status = new LoginResultStatus()
	user = new UserResource()
	authorization = new LoginResultAuthorizationResource()
}

export class LoginResultAuthorizationResource
{
	token = null
	type = null
	tfa_token = null
}

export class LoginResultStatus
{
	static Success = 'success'
	static TfaRequired = 'tfa_required'
	static Unknown = 'unknown'
}
